module.exports = __webpack_public_path__ + "static/media/R8VLR.9f29563f.jpg";